module.exports = __webpack_public_path__ + "static/media/021-snowing-2.cc5e0b53.svg";